<template>
  <div v-if="
  this.enableAccessAuthCreate('Q1') === true &&
  this.getDetailBasic.tag !== 'M5'">
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    v-if="data.btnType !== 'icon'">
      <v-icon left>
        add
      </v-icon>
      {{data.btnTitle}}
    </v-btn>
    <v-layout v-else class="text-xs-right">
      <v-btn @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> shopping_bag </v-icon>
      </v-btn>
    </v-layout>

    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Order
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 0">
              <div v-if="this.data.info !== null">
                <DocumentSourceInfo/>
                <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon :color="ui.colorWarning">
                      {{orderObj.icon1}}
                    </v-icon>
                    </v-avatar>
                    <span :class="ui.textWarning">
                      {{orderObj.title1}}
                    </span>
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <span :class="ui.textWarning">
                      {{orderObj.data1}}
                    </span>
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 mt-0">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon>
                      {{orderObj.icon2}}
                    </v-icon>
                    </v-avatar>
                    {{orderObj.title2}}
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <span class="hidden-xs-only">
                      {{orderObj.data2}}
                    </span>
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 mt-0">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon>
                      {{orderObj.icon3}}
                    </v-icon>
                    </v-avatar>
                    {{orderObj.title3}}
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    {{orderObj.data3}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 mt-0">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon>
                      savings
                    </v-icon>
                    </v-avatar>
                    Budget
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                  v-if="this.getDetailLink.bdid !== ''">
                    {{this.getDetailLink.bid}}
                  </v-chip>
                  <v-chip v-else :color="ui.bkgdColor" :class="ui.textSubheading">
                    Budget Required
                  </v-chip>
                </v-layout>
              </div>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.name"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="shopping_bag"
                  hint="order name or title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs8>
                  <v-text-field
                  v-model="localForm.tag"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="fingerprint"
                  hint="order id or tag"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 v-if="this.data.info.basic.tag !== 'H5'">
                  <v-text-field
                  v-model="localForm.itemQty"
                  :rules="mustBeZeroOrMore"
                  prepend-icon="widgets"
                  hint="qty"
                  persistent-hint
                  required
                  :readonly="!this.orderObj.enableUnits"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-4" v-if="data.info.basic.tag === 'H5'">
                <v-spacer/>
                <v-chip :color="ui.chipColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon>
                    shopping_bag
                  </v-icon>
                  </v-avatar>
                  <span :class="ui.textBlue">
                    {{data.info.char.hrs}} hrs | {{data.info.char.per}} per |
                    {{this.calcResourcePersonHours(data.info.char)}}
                  </span>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-4" v-if="data.info.basic.tag === 'L5'">
                <v-spacer/>
                <v-chip :color="ui.chipColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon>
                    shopping_bag
                  </v-icon>
                  </v-avatar>
                  ${{data.info.char.cost}} | {{data.info.char.carb}} kg (per unit)
                </v-chip>
              </v-layout>
              <v-layout row class="mr-4">
                <v-spacer/>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="
                this.data.info.basic.tag === 'L5'
                ">
                  <v-icon left :color="ui.btnColor"> co2 </v-icon>
                    <div :class="ui.textSubheadingBold">
                    {{this.calcPartCarbon(data.info.char)}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="this.data.info.basic.tag === 'L5'">
                  <v-icon left :color="ui.btnColor"> paid </v-icon>
                    <div :class="ui.textSubheadingBold">
                    {{this.calcPartCost(data.info.char)}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="this.data.info.basic.tag === 'H5'">
                  <v-icon left :color="ui.btnColor"> paid </v-icon>
                    <div :class="ui.textSubheadingBold">
                      {{this.calcResourceCost(data.info.char)}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="this.data.info.basic.tag === 'L7'">
                  <v-icon left :color="ui.btnColor"> co2 </v-icon>
                    <div :class="ui.textSubheadingBold">
                    {{this.calcMaterialOrderCarbon(this.getDetailChar.carb, this.localForm.itemQty)}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="this.data.info.basic.tag === 'L7'">
                  <v-icon left :color="ui.btnColor"> paid </v-icon>
                    <div :class="ui.textSubheadingBold">
                      {{this.calcMaterialOrderCost(this.getDetailChar.cost, this.localForm.itemQty)}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-4">
                <div :class="ui.textSubheading">
                  Order Description and Objective
                </div>
              </v-layout>
              <v-layout row wrap class="ml-3 mr-2">
                <v-flex xs11>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="order request"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="order scope and technical purpose"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> shopping_bag </v-icon>
                  </v-avatar>
                  Order
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> shopping_bag </v-icon>
                  </v-avatar>
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  Tag
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  Type
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> widgets </v-icon>
                  </v-avatar>
                  Qty
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemQty}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> widgets </v-icon>
                  </v-avatar>
                  Qty
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemQty}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> category </v-icon>
                  </v-avatar>
                  Detail
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-if="this.data.info.basic.tag === 'H5'">
                  {{data.info.char.hrs}} hrs | {{data.info.char.per}} per |
                  {{this.calcResourcePersonHours(data.info.char)}}
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="this.data.info.basic.tag === 'L5'">
                    <div :class="ui.textSubheadingBold">
                      {{this.data.info.char.type}}
                    </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="this.data.info.basic.tag === 'L7'">
                    <div :class="ui.textSubheadingBold">
                      {{this.getDetailBasic.title}}
                    </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> category </v-icon>
                  </v-avatar>
                  <span :color="ui.bkgdColor" :class="ui.textSubheading"
                  v-if="this.data.info.basic.tag === 'H5'">
                    {{data.info.char.hrs}} hrs | {{data.info.char.per}} per |
                    {{this.calcResourcePersonHours(data.info.char)}}
                  </span>
                  <span :color="ui.chipColor" :text-color="ui.textColor"
                  v-if="this.data.info.basic.tag === 'L5'">
                      <div :class="ui.textSubheadingBold">
                        {{this.data.info.char.type}}
                      </div>
                  </span>
                  <span :color="ui.chipColor" :text-color="ui.textColor"
                  v-if="this.data.info.basic.tag === 'L7'">
                      <div :class="ui.textSubheadingBold">
                        {{this.getDetailBasic.title}}
                      </div>
                  </span>
                </v-chip>

              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-if="this.data.info.basic.tag === 'H5'">
                  <v-avatar>
                  <v-icon> paid </v-icon>
                  </v-avatar>
                  {{this.calcResourceCost(data.info.char)}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-if="this.data.info.basic.tag === 'L5'">
                  <v-avatar>
                  <v-icon> co2 </v-icon>
                  </v-avatar>
                  {{this.calcPartCarbon(data.info.char)}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-if="this.data.info.basic.tag === 'L5'">
                  <v-avatar>
                  <v-icon> paid </v-icon>
                  </v-avatar>
                  {{this.calcPartCost(data.info.char)}}
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                class="hidden-xs-only"
                v-if="this.data.info.basic.tag === 'L7'">
                  <v-icon left :color="ui.btnColor"> co2 </v-icon>
                    <div :class="ui.textSubheadingBold">
                    {{this.calcMaterialOrderCarbon(this.getDetailChar.carb, this.localForm.itemQty)}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="this.data.info.basic.tag === 'L7'">
                  <v-icon left :color="ui.btnColor"> paid </v-icon>
                    <div :class="ui.textSubheadingBold">
                      {{this.calcMaterialOrderCost(this.getDetailChar.cost, this.localForm.itemQty)}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            Next
            <v-icon right> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up"
          >
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createNewOrder()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid"
          class="hidden-sm-and-up"
          v-if="enableSubmit"
          @click="createNewOrder()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import orderFunctions from "@/data/functions/mixins/orderFunctions.js";
import relpsFunctions from "@/data/functions/mixins/relpsFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import orderOptions from "@/data/options/mixins/orderOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import moment from "moment";
import describeDocument from "@/data/describe/mixins/describeDocument";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import DocumentSourceInfo from "@/document/info/components/DocumentSourceInfo";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin,
    DocumentSourceInfo
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    describeDocument,
    docRevsModFunctions,
    orderFunctions,
    createFirebase,
    ruleTextfield,
    facilityOptions,
    techOptions,
    storeFunctions,
    changeDetail,
    relpsFunctions,
    relationshipsFunctions,
    generateID,
    generateForms,
    accessFunctions,
    financeFunctions,
    orderOptions,
    numberFunctions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        name: "",
        tag: "",
        type: "",
        theme: "IT1",
        des: "",
        itemQty: "1"
      },
      info: [
        {
          step: 0,
          title: "Order",
          // eslint-disable-next-line
          msg: "Order is used where transfer of value must be managed. The transaction is typically between facility and external provider. The operation involves transfer of funds for goods and services.",
          icon: ""
        },
        {
          step: 1,
          title: "Order Info",
          // eslint-disable-next-line
          msg: "Order request description is used by the facility or project to understand the context of order priority.",
          icon: ""
        },
        {
          step: 2,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify new order information. If you need to edit then return to previous steps. The review team will confirm the order requirements and publish order as required.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  beforeMount() {
    // GENERATE ORDER TITLE
    let orderTitle = "ORD " + this.data.info.basic.idi;
    orderTitle = orderTitle + " " + this.data.info.basic.id;
    this.localForm.name = orderTitle;
    // GENERATE ORDER ID
    if (this.getDetailBasic !== null && this.getDetailStats !== null) {
      let id = this.generateIDfromMaster(
        this.getDetailBasic.tag,
        this.getDetailBasic.idg,
        this.getDetailStats.nq1
      );
      this.localForm.tag = id;
    }
    // GENERATE DES + TYPE
    if (this.getDetail !== null && this.data.info !== null) {
      // eslint-disable-next-line
      let text = null;
      let idgen = null;
      if (this.getDetail.basic.tag === "L1") {
        this.localForm.type = "ML1";
        // eslint-disable-next-line
        idgen = this.displayDocumentIDGTypeA(this.getDetailBasic.tag, this.getDetailBasic.idg);
        text = "Order for Material " + idgen;
        // eslint-disable-next-line
        idgen = this.displayDocumentIDGTypeA(this.data.info.basic.tag, this.data.info.basic.idg);
        text = text + " and Inventory " + idgen + ".";
      } else if (this.getDetail.basic.tag === "W1") {
        // eslint-disable-next-line
        idgen = this.displayDocumentIDGTypeA(this.getDetailBasic.tag, this.getDetailBasic.idg);
        text = "Order for Work Request " + idgen;
        text = text + " and ";
        if (this.data.info.basic.tag === "H5") {
          this.localForm.type = "SW1";
          // eslint-disable-next-line
          idgen = this.displayDocumentIDGTypeA(this.data.info.basic.tag, this.data.info.basic.idg);
          text = text + "Resource ";
          text = text + idgen + ".";
        } else if (this.data.info.basic.tag === "L5") {
          this.localForm.type = "PW1";
          this.localForm.itemQty = this.data.info.char.qty;
          // eslint-disable-next-line
          idgen = this.displayDocumentIDGTypeA(this.data.info.basic.tag, this.data.info.basic.idg);
          text = text + "Part ";
          text = text + idgen + ".";
        } else {
          text = text + "DONE";
        }
      } else {
        text = "Order or Work ";
      }
      // eslint-disable-next-line
      this.localForm.des = text;
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getDetail",
      "getDetailBasic",
      "getDetailStats",
      "getDetailLink"
    ]),
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    orderObj() {
      let obj = {
        enableUnits: true,
        title1: "",
        icon1: "",
        datta1: "",
        title2: "",
        icon2: "",
        data2: "",
        title3: "",
        icon3: "",
        data3: ""
      };
      let tag = this.data.info.basic.tag;
      if (tag === "H5") {
        obj.enableUnits = false;
        obj.title1 = "Service Order";
        obj.icon1 = "shopping_bag";
        obj.data1 = this.localForm.tag;

        obj.title2 = this.data.info.basic.title;
        obj.icon2 = "groups";
        obj.data2 = this.data.info.basic.id;

        obj.title3 = "Order Type";
        obj.icon3 = "grid_view";
        obj.data3 = this.localForm.type;
      }
      if (tag === "L5") {
        obj.enableUnits = false;
        obj.title1 = "Part Order";
        obj.icon1 = "shopping_bag";
        obj.data1 = this.localForm.tag;

        obj.title2 = this.data.info.basic.title;
        obj.icon2 = "category";
        obj.data2 = this.data.info.basic.id;

        obj.title3 = "Order Type";
        obj.icon3 = "grid_view";
        obj.data3 = this.localForm.type;
      }
      if (tag === "L7") {
        obj.enableUnits = true;
        obj.title1 = "Inventory Order";
        obj.icon1 = "shopping_bag";
        obj.data1 = this.localForm.tag;

        obj.title2 = this.data.info.basic.title;
        obj.icon2 = "warehouse";
        obj.data2 = this.data.info.basic.id;

        obj.title3 = "Order Type";
        obj.icon3 = "grid_view";
        obj.data3 = this.localForm.type;
      }
      return obj;
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 2 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (
        this.step == 0 &&
        this.getDetailLink.bdid !== undefined &&
        this.getDetailLink.bdid !== null &&
        this.getDetailLink.bid !== ""
      ) {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.name !== "" &&
        this.localForm.tag !== "" &&
        this.localForm.des !== "" &&
        this.localForm.itemQty !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      // download facility which is used for asset
      // this.getDocumentFacilityOnly(this.getUser.pref.select.fdid);
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNewOrder() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "Q1";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");
      const idm = this.defineIDGShortLastSix(this.getDetail.basic.idg);

      // GENERATE form
      let temp = this.generateOrderForm(); // form is from compnew component
      // BASIC
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.idm = idm;
      temp.basic.tag = tag;
      temp.basic.act = true; // set asset to true
      temp.basic.title = this.localForm.name;
      temp.basic.id = this.localForm.tag;

      // CHAR
      temp.char.des = this.localForm.des;
      temp.char.qty = this.localForm.itemQty;
      temp.char.type = this.localForm.type;
      temp.char.theme = this.localForm.theme;
      temp.char.dis = this.getDetailChar.dis;

      // CHAR for Material
      if (this.getDetailBasic.tag === "L1") {
        // temp.char.costo = this.calcMaterialOrderCostOnly(this.getDetailChar.cost, this.localForm.itemQty)
        // temp.char.costo = this.getDetailChar.cost;
        // temp.char.carbo = this.getDetailChar.carb;
      }
      // CHAR for Parts
      if (this.data.info.basic.tag === "L5") {
        // GENERAL DATA
        temp.char.dis = this.data.info.char.dis; // overwrite
        temp.char.order = this.data.info.char.com;
        // COST
        temp.char.costo = this.data.info.char.cost;
        temp.char.costu = this.data.info.char.costu;
        temp.char.carbo = this.data.info.char.carb;
        temp.char.carbu = this.data.info.char.carbu;
        // BASIC DATA
        temp.char.ordn = this.data.info.basic.title;
        temp.char.ordi = this.data.info.basic.id;
        temp.char.ordt = this.data.info.char.type;
        temp.char.ordq = this.data.info.char.qty;
        temp.char.ordc = this.data.info.char.add;
      }

      if (this.data.info.basic.tag === "H5") {
        // GENERAL DATA
        temp.char.dis = this.data.info.char.dis; // overwrite
        temp.char.order = this.data.info.char.com;
        // COST
        temp.char.costo = this.calcResourceCostOnly(this.data.info.char);
        temp.char.costu = this.data.info.char.costu;
        temp.char.carbo = 10;
        temp.char.carbu = this.data.info.char.carbu;
        temp.char.rate = this.data.info.char.rate;
        temp.char.per = this.data.info.char.per;
        temp.char.hrs = this.data.info.char.hrs;
        // BASIC DATA
        temp.char.ordn = this.data.info.basic.title;
        temp.char.ordi = this.data.info.basic.id;
        temp.char.ordt = this.data.info.char.type;
        temp.char.ordq = this.calcResourcePersonHours(this.data.info.char);
      }
      // STATS
      temp.stats.dcrt = moment().format();
      // eslint-disable-next-line
      temp.stats.drev = moment().add(1, 'months').format();
      // eslint-disable-next-line
      temp.stats.deta = moment().add(2, 'months').format();
      // eslint-disable-next-line
      temp.stats.ddue = moment().add(4, 'months').format();
      // eslint-disable-next-line
      temp.stats.dmob= moment().add(2, 'months').format();
      // eslint-disable-next-line
      temp.stats.demob = moment().add(3, 'months').format();
      // REV data
      temp.rev = this.generateInitialDocumentRev(tag);

      // TRANS
      let trans = this.generateInitalTransition(tag); // model
      temp.trans = trans;

      // LINK DOCUMENT INFO
      if (this.getDetail !== null && this.data.info !== null) {
        // LINK FACILITY
        if (this.getUser.pref.select.fdid !== "") {
          temp.link.fdid = this.getUser.pref.select.fdid;
          temp.link.ft = this.getUser.pref.select.fname;
          temp.link.fid = this.getUser.pref.select.fid;
        }
        // LINK BUDGET
        if (this.getDetailLink !== null) {
          temp.link.bdid = this.getDetailLink.bdid; // facility did
          temp.link.bid = this.getDetailLink.bid; // facility id
          temp.link.bidg = this.getDetailLink.bidg; // facility idg
          temp.link.bt = this.getDetailLink.bt; // facility title
          temp.link.btag = this.getDetailLink.btag;
        }
        // LINK SOURCE DOCUMENT
        temp.link.sdid = this.getDetail.basic.did; // detail did
        temp.link.sid = this.getDetail.basic.id; //  detil id
        temp.link.sidg = this.getDetail.basic.idg; // detail facility idg
        temp.link.st = this.getDetail.basic.title; // detail  title
        temp.link.stag = this.getDetail.basic.tag; // detail title

        // UPDATE SOURCE DATA DOUCMENT QTR
        if (this.data.info.basic.tag === "L5") {
          // temp.relps.l5.push(this.data.info); // parts
          this.changeOrderListItemStatus("Order", this.data.info, temp);
          this.saveDocumentRevMod(5.61, 1); // material order
        }
        if (this.data.info.basic.tag === "H5") {
          // temp.relps.h5.push(this.data.info); // human resources
          this.changeOrderListItemStatus("Order", this.data.info, temp);
          this.saveDocumentRevMod(5.61, 1); // material order
        }
        if (this.data.info.basic.tag === "L7") {
          // temp.relps.l7.push(this.data.info); // human resources
          // eslint-disable-next-line
          this.changeOrderListItemMaterialOnOrderCounter(temp.char.qty, this.data.info);
          this.saveDocumentRevMod(5.61, 1); // material order
        }
        // UPDATE MASTER DOCUMENT DETAIL with new order stats
        let tempMaster = this.getDetail;
        tempMaster.stats.nq1 = tempMaster.stats.nq1 + 1;
        tempMaster.stats.nq1o = tempMaster.stats.nq1o + 1;
        this.$store.dispatch("changeDetail", tempMaster);
        this.changeDetail();
      }
      // HELP
      console.log("");
      console.log("NEW Order");
      console.log(temp);
      // CREATE ORDER for MASTER DOCCUMENT
      this.createFirebaseDocumentOnly(temp);
    }
  }
};
</script>
